export default "__VITE_ASSET__DCj6pWZV__ 800w, __VITE_ASSET__C1bXIP$S__ 1280w, __VITE_ASSET__Py8iY17A__ 1920w";